import { render } from "./newFournisor.vue?vue&type=template&id=6e0fcdb8&scoped=true"
import script from "./newFournisor.vue?vue&type=script&lang=js"
export * from "./newFournisor.vue?vue&type=script&lang=js"

import "./newFournisor.vue?vue&type=style&index=0&id=6e0fcdb8&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0fcdb8"]])

export default __exports__